angular.module("customerDigital.components", [])
  .component("customerDigital", {
    templateUrl: "ng/components/richiestaPreventivo/customerDigital/customerDigital.view.html",
    bindings: {
      id: "=",
      exportValidityCustomerDigital: "&",
      exportValidateCf: "&",
      switchOptions: "=",
      exportModel: "&",
      initialSubject: "=",
      financialCustomer: "=",
      portal: "=",
      productType: "=",
      defaultMode: "=",
      optionsIsChanged: "<",
      isRichiestaVoltura: "<",
      initialTabIndex: "=",
      impostaRegistro: "<",
      snapshot: '<',
      cf: "&",
      isRichiestaPreventivo: "<"
    },
    controllerAs: "customerDigitalCtrl",
    controller: function Customer(
      $financialApiService,
      $portalService,
      $rootScope,
      $scope,
      Stato,
      validationService,
      Pf,
      Residenza,
      $timeout,
      RiUserG,
      $modalService,
      Sede,
      $typeDomainService,
      $giuridicVersion
    ) {
      var self = this;

      self.$onInit = function () {
        self.$giuridicVersion = $giuridicVersion;
        self.currentCustomer = {}
        self.mapComuni = $rootScope.comuniMap;
        self.mapComuniNsilSoppressi = $rootScope.mapComuniSoppressi;
        self.nazioniEstere = $rootScope.nazioniEstere
        self.enableErrorCF = true;
        self.numberOfCharMax = 40;
        self.numberOfCharMaxRagSoc = 33;
        self.loaderLente = false;
        self.ricercaEffettuata = false;
        self.type = self.defaultMode === 'PERSONA' ? 'F' : 'G';
        self.invalidField = false;
        checkAndEnableTooltip();
        listOfLegalStatusNotDataAvvioAttivita();
        self.supportModel = {
          cf: "",
          ragioneSociale: "",
          nominativo: "",
          nome: "",
          cognome: "",
          subjectResponse: "",
          valueModel: "",
          indirizzoCliente: "",
          validityCf: false,
          labelProductType: "",
          endSearchRest: false,
          rbValue: 'rbPiva',
          initialIndex: 0,
          sedeLegale: {},
          formaGiuridica: "",
          indirizzoPF: ""
        }

        if (self.snapshot) {
          self.initialSubject.riUserF = self.initialSubject.riUserF && self.initialSubject.riUserF.listaPf && self.initialSubject.riUserF.listaPf.length ? self.initialSubject.riUserF.listaPf[0] : (self.initialSubject.riUserF && !self.initialSubject.riUserF.listaPf ? self.initialSubject.riUserF : null);

          self.ricercaEffettuata = true;
          self.supportModel.cf = self.initialSubject.riUserG ? self.initialSubject.riUserG.cf : self.initialSubject.riUserF.cf;
          self.supportModel.ragioneSociale = self.initialSubject.riUserG && self.initialSubject.riUserG.ragioneSociale
        }


        self.listaProvince = $rootScope.comuniMap
          .map(function (comune) {
            return comune.sigla;
          })
          .filter(function (siglaComune) {
            return siglaComune != "";
          })
          .sort()
          .reduce(function (result, nextItem) {
            return result.includes(nextItem) ? result : result.concat(nextItem);
          }, [])
          .filter(function (elem) {
            return elem != "EE"
          });

        self.$portalService = $portalService;
        self.$rootScope = $rootScope;
        self.supportModel.initialIndex = self.initialTabIndex || 0;

        if (self.id === "dateRequest") {
          if (self.initialSubject.azienda) {
            self.initialSubject.riUserG = self.initialSubject.azienda;
          }
          if (self.initialSubject.persona) {
            self.initialSubject.riUserF = self.initialSubject.persona;
          }
        }

        // POPOLA I CAMPI DELLA MAPPA PRESENTI NEL MODELLO
        //se ditta individuale
        if (self.initialSubject && self.initialSubject.riUserG && self.initialSubject.riUserG.sedeLegale &&
          self.initialSubject.riUserG.sedeLegale.indirizzo && self.initialSubject.riUserF && self.initialSubject.riUserF.cf) {
          self.defaultMode = 'AZIENDA';
          self.supportModel.anagCancelled = self.initialSubject.riUserG.deleted;
          self.supportModel.ragioneSociale = self.initialSubject.riUserG.ragioneSociale
          self.supportModel.indirizzoCliente = self.initialSubject.riUserF.residenza
          self.supportModel.cf = self.initialSubject.riUserF.cf;
          self.supportModel.nome = self.initialSubject.riUserF.nome;
          self.supportModel.cognome = self.initialSubject.riUserF.cognome;
          self.supportModel.subjectResponse = self.initialSubject.riUserF

          if (self.initialSubject.riUserF.ndg) { // CENSITO
            self.showSearchFallbackF = false;
          } else { // NON CENSITO
            self.showSearchFallbackF = true;
            if (self.supportModel.nome && self.supportModel.cognome && self.supportModel.cf) {
              self.validityCf(self.supportModel.cf, self.supportModel.cognome, self.supportModel.nome);
            }
          }

          if (self.supportModel.cf) {
            self.ricercaEffettuata = true;
          }

          //se persona giuridica  
        } else if (self.initialSubject && self.initialSubject.riUserG &&
          self.initialSubject.riUserG.sedeLegale && self.initialSubject.riUserG.sedeLegale.indirizzo) {
          self.supportModel.anagCancelled = self.initialSubject.riUserG.deleted;
          self.defaultMode = 'AZIENDA';
          if ($giuridicVersion.checkIfInd(self.initialSubject.riUserG.formaGiuridica)) {
            self.supportModel.cf = self.initialSubject.riUserG.cf;
          } else {
            self.supportModel.cf = self.initialSubject.riUserG.piva;
          }

          if (self.id === "vendorPaymentDetail" && self.supportModel.cf === '0') {
            self.supportModel.cf = self.initialSubject.riUserG.ndg;
            if (self.supportModel.cf) {
              self.supportModel.rbValue = false;
              self.ricercaEffettuata = true;
            }
          }
          self.supportModel.ragioneSociale = self.initialSubject.riUserG.ragioneSociale
          self.supportModel.sedeLegale = self.initialSubject.riUserG.sedeLegale
          self.supportModel.formaGiuridica = self.initialSubject.riUserG.formaGiuridica
          self.supportModel.indirizzoCliente = self.initialSubject.riUserG.sedeLegale

          if (self.supportModel.cf) {
            self.ricercaEffettuata = true;
          }

          //se persona fisica
        } else if (self.initialSubject && self.initialSubject.riUserF && self.initialSubject.riUserF.cf) {
          if (self.id === "RICHPREVE") {
            self.defaultMode = 'AZIENDA'
          } else {
            self.defaultMode = 'PERSONA';
            self.type = "F"
          }
          self.supportModel.anagCancelled = self.initialSubject.riUserF.deleted
          self.supportModel.indirizzoCliente = self.initialSubject.riUserF.residenza
          self.supportModel.cf = self.initialSubject.riUserF.cf;
          self.supportModel.nome = self.initialSubject.riUserF.nome;
          self.supportModel.cognome = self.initialSubject.riUserF.cognome;
          if (self.supportModel.nome && self.supportModel.cognome) {
            self.supportModel.nominativo = self.supportModel.nome + ' ' + self.supportModel.cognome;
          }

          if (self.initialSubject.riUserF.ndg) { // CENSITO
            self.showSearchFallbackF = false;
          } else { // NON CENSITO
            self.showSearchFallbackF = true;
            if (self.supportModel.nome && self.supportModel.cognome && self.supportModel.cf) {
              self.validityCf(self.supportModel.cf, self.supportModel.cognome, self.supportModel.nome);
            }
          }

          if (
            self.supportModel.cf
          ) {
            if (isNaN(self.supportModel.cf)) {
              self.supportModel.rbValue = 'rbCF'
            }
            self.ricercaEffettuata = true;
          }
        } else if (self.initialSubject && !self.initialSubject.riUserF && !self.initialSubject.riUserG && !self.id === "insuredSubject") {
          self.supportModel.cf = self.initialSubject
        } else if (self.initialSubject && !self.initialSubject.riUserF && !self.initialSubject.riUserG && self.id === "insuredSubject") {
          self.supportModel.cf = self.initialSubject.cf;
          self.supportModel.nome = self.initialSubject.nome;
          self.supportModel.cognome = self.initialSubject.cognome;
          self.supportModel.nominativo = self.supportModel.nome + " " + self.supportModel.cognome;
          self.supportModel.indirizzoCliente = self.initialSubject.residenza;
          if (!self.initialSubject.datiIncompleti && self.supportModel.cf != "") {
            self.ricercaEffettuata = true;
            self.validityCf(self.supportModel.cf, self.supportModel.cognome, self.supportModel.nome);
          }
        } else if (self.initialSubject && self.initialSubject.riUserG && self.initialSubject.riUserG.cf && self.id === 'additionalGoodInfo') {
          self.supportModel.cf = self.initialSubject.riUserG.cf;
        } else if (self.id === "vendorPaymentDetail" && typeof self.initialSubject == 'string') {
          self.supportModel.cf = self.initialSubject;
        }

        switch (self.defaultMode) {
          case "AZIENDA":
            if (self.initialSubject && self.initialSubject.riUserG && $giuridicVersion.checkIfInd(self.initialSubject.riUserG.formaGiuridica)) {
              self.labelPlaceholder('LBL_SOCIETY_CF', 'PLACEHOLDER_FISCAL_CODE_CORPORATE');
              self.supportModel.valueModel = 'riUserG'
              self.supportModel.rbValue = 'rbCF';
            } else {
              self.labelPlaceholder('LBL_PF_PIVA', 'LBL_PIVA_PLACEHOLDER');
              self.supportModel.valueModel = 'riUserG'
            }
            break;
          case "PERSONA":
            self.labelPlaceholder('LBL_PERSONAL_FISCAL_CODE', 'PLACEHOLDER_FISCAL_CODE_PERSONAL');
            self.supportModel.valueModel = 'riUserF'
            break;
          default:
            self.labelPlaceholder('LBL_SOCIETY_CF', 'PLACEHOLDER_FISCAL_CODE_CORPORATE')
        }

        if (self.ricercaEffettuata) {
          self.validityCustomerDigital(true);
        } else {
          self.validityCustomerDigital(false)
        }

        self.checkProductType();
      }

      self.$onChanges = function (changed) {
        if (self.supportModel && changed.optionsIsChanged) {
          if (changed.optionsIsChanged.currentValue) {
            self.supportModel.hidePiva = true;
            self.supportModel.rbValue = 'rbCF'
            self.type = 'F'
            self.handleChange('rbCF', self.switchOptions[0]);
          } else {
            self.type = 'G';
            self.supportModel.hidePiva = false;
            self.handleChange('rbPiva');
          }

        }
      }

      self.labelPlaceholder = function (label, placeholder) {
        self.labelCodiceFiscale = label;
        self.placeholderCodiceFiscale = placeholder;
      }

      self.assignNomeCognome = function (subjectResponse) {
        if (subjectResponse.metadata && subjectResponse.metadata.riUserF) {
          subjectResponse.metadata.riUserF.nome = self.supportModel.nome;
          subjectResponse.metadata.riUserF.cognome = self.supportModel.cognome
        }
      }

      self.checkNomeCognome = function (subjectResponse, valueModel) {
        if (self.supportModel.nome && self.supportModel.cognome) {
          if (valueModel === 'riUserG' && $giuridicVersion.checkIfInd(subjectResponse.metadata.riUserG.formaGiuridica)) {
            self.assignNomeCognome(subjectResponse);
          } else if (valueModel === 'riUserG' && !$giuridicVersion.checkIfInd(subjectResponse.metadata.riUserG.formaGiuridica)) {
            subjectResponse.metadata.riUserG.ragioneSociale = self.supportModel.nome + ' ' + self.supportModel.cognome
          } else {
            self.assignNomeCognome(subjectResponse);
          }
        }
        self.validityModel(subjectResponse);
      }

      self.handleChange = function (property, value) {
        var type = self.type === 'G' ? 'AZIENDA' : 'PERSONA';
        self.alertPivaEstera = false;
        switch (property) {
          case 'nome':
            break;
          case 'cognome':
            self.supportModel[property] = value;

            self.checkNomeCognome(self.supportModel.subjectResponse, self.supportModel.valueModel);
            self.validityCf(self.currentCustomer.cf, self.supportModel.cognome, self.supportModel.nome);
            if (self.id === "RICHPREVE") {
              self.validitySede = true;
            }
            if (self.supportModel.validityCf && self.validitySede) {
              self.validityCustomerDigital(true);
            } else {
              self.validityCustomerDigital(false);
            }
            break;
          case 'cf':
            self.invalidField = false;
            if (self.supportModel.cf && self.supportModel.cf != value) {
              const supportModelConst = self.supportModel;
              // self.supportModel = {
              //   cf: supportModelConst.cf,
              //   ragioneSociale: "",
              //   nominativo: "",
              //   nome: "",
              //   cognome: "",
              //   subjectResponse: "",
              //   valueModel: supportModelConst.valueModel,
              //   indirizzoCliente: "",
              //   validityCf: false,
              //   labelProductType: "",
              //   endSearchRest: false,
              //   rbValue: true,
              //   initialIndex: 0,
              //   sedeLegale: {},
              //   formaGiuridica: "",
              //   indirizzoPF: ""
              // }
              self.supportModel.cf = supportModelConst.cf;
              self.currentCustomer = supportModelConst;
              self.supportModel.valueModel = supportModelConst.valueModel;
              self.ricercaEffettuata = false;
              self.validityCustomerDigital(false);
            }
            self.currentCustomer.cf = value && value.toUpperCase();
            self.supportModel.cf = value && value.toUpperCase();
            self.cf({
              valore: self.supportModel.cf
            });

            if (!self.supportModel) {
              self.ricercaEffettuata = false;
              self.showSearchFallbackF = false
            }
            if (type == 'PERSONA' && value && value.length == 16 && isNaN(value)) {
              self.enableErrorCF = validationService.validateCf(value);
            } else {
              self.enableErrorCF = true;
            }
            $scope.customerDigitalForm && console.log($scope.customerDigitalForm.$valid)
            if (self.typeCf != 'ndg' && value) {
              self.alertPivaEstera = !validationService.cfPiva.test(value);
            }
            break;
          case 'sedeLegale':
            self.supportModel.indirizzoCliente = value;

            if (self.supportModel.indirizzoCliente) {
              if (self.supportModel.cf && self.supportModel.nome && self.supportModel.cognome && self.supportModel.validityCf && self.validitySede) {
                self.validityCustomerDigital(true);
              } else {
                self.validityCustomerDigital(false);
              }
            } else {
              self.validityCustomerDigital(false);
            }
            self.validityModel(self.supportModel.subjectResponse);
            checkAndEnableTooltip()
            break;
          case 'rbCF':
            //self.labelPlaceholderChangeOption(type, 'LBL_SOCIETY_CF', 'PLACEHOLDER_FISCAL_CODE_CORPORATE');
            self.changeOption(type);
            break;
          case 'rbNdg':
            //self.labelPlaceholderChangeOption(type, 'LBL_NDG', 'PF_INSERT_NDG');
            self.changeOption(type);
            break;
          case 'rbPiva':
            self.changeOption(type);
          case 'ragioneSociale':
            break;
          default:
            break;
        }

        if ($giuridicVersion.checkIfInd(self.supportModel.formaGiuridica)) {

          self.validitySede =
            self.supportModel.sedeLegale &&
            Sede.build(self.supportModel.sedeLegale).isOk(true) &&
            self.supportModel.indirizzoCliente &&
            Sede.build(self.supportModel.indirizzoCliente).isOk(false, true) && self.supportModel.validityCf;
        } else if (
          !$giuridicVersion.checkIfInd(self.supportModel.formaGiuridica) ||
          !self.supportModel.formaGiuridica
        ) {
          self.validitySede =
            self.supportModel.sedeLegale &&
            Sede.build(self.supportModel.sedeLegale).isOk(true) && self.supportModel.validityCf;
        }

        if (
          self.supportModel.indirizzoCliente &&
          Sede.build(self.supportModel.indirizzoCliente).isOk(true)
        ) {
          self.validitySede =
            self.supportModel.indirizzoCliente &&
            Sede.build(self.supportModel.indirizzoCliente).isOk(false, true) && self.supportModel.validityCf;
        }

        if (self.supportModel.indirizzoCliente && self.supportModel.nome && self.supportModel.cognome && self.supportModel.cf) {
          var obj = {
            nome: self.supportModel.nome,
            cognome: self.supportModel.cognome,
            residenza: self.supportModel.indirizzoCliente,
            cf: self.supportModel.cf
          }

          if (self.id == 'POSTVENDITA') {
            if (self.financialCustomer) {
              self.financialCustomer.riUserF = obj;
            }
          } else {
            if (self.financialCustomer) {
              self.financialCustomer.metadata.riUserF = obj;
            }
          }
        }

        if (self.supportModel.subjectResponse && self.supportModel.subjectResponse.metadata && self.supportModel.subjectResponse.metadata.riUserF) {
          self.supportModel.subjectResponse.metadata.riUserF.nome = self.supportModel.nome;
          self.supportModel.subjectResponse.metadata.riUserF.cognome = self.supportModel.cognome;
          if (isNaN(self.supportModel.cf)) {
            self.supportModel.subjectResponse.metadata.riUserF.cf = self.supportModel.cf;
          }
          self.supportModel.subjectResponse.metadata.riUserF.residenza = self.supportModel.indirizzoCliente;
          self.validityModel(self.supportModel.subjectResponse);
        }

        if (!self.supportModel.cf) {
          self.inBlacklist = false
          self.validityCustomerDigital(false);
          self.validityModel(self.supportModel.subjectResponse);
        }

        if (self.id == 'RICHPREVE') {
          if (self.notFound && self.supportModel.cf && self.supportModel.ragioneSociale) {
            self.validateCf(false);
            self.validityCustomerDigital(true);
            self.financialCustomer.metadata.riUserG.cf = self.supportModel.cf;
            self.financialCustomer.metadata.riUserG.ragioneSocialeProposta = self.supportModel.ragioneSociale;
            self.financialCustomer.metadata.riUserG.ragioneSociale = self.supportModel.ragioneSociale;
          } else if (self.notFound && (!self.supportModel.cf || !self.supportModel.ragioneSociale)) {
            self.validityCustomerDigital(false);
          } else if (self.ricercaEffettuata) {
            self.validateCf(true);
          }
        }
      }

      self.setTypeCf = function (typeRb) {
        //   self.typeCf;
        //   if (typeRb == "rbNdg") {
        //     self.typeCf = "ndg";
        //   } else {
        //     self.typeCf = self.defaultMode === "AZIENDA" ? "cfPivaPlus" : "cf";
        //   }
        //   return self.typeCf;

        switch (self.labelCodiceFiscale) {
          case "LBL_PF_PIVA":
            self.typeCf = "cfPivaPlus";
            self.type = "G";
            self.defaultMode = 'AZIENDA'
            break;
          case "LBL_SOCIETY_CF":
            self.typeCf = "cfPivaPlus";
            self.type = "G";
            break;
          case "LBL_PERSONAL_FISCAL_CODE":
            self.typeCf = "cf";
            self.type = "F";
            break;
          case "LBL_NDG":
            self.typeCf = "ndg";
            self.type = "G";
            break;
          default:
            self.type = undefined;
        }
        return self.typeCf;
      };

      self.labelPlaceholderChangeOption = function (defaultMode, label, placeholder) {
        self.labelCodiceFiscale = label;
        self.placeholderCodiceFiscale = placeholder;
      }

      self.changeOption = function (property) {
        self.ricercaEffettuata = false;
        self.notFound = false;
        self.supportModel.anagCancelled = false;
        switch (property) {
          case "AZIENDA":
            self.type = "G";
            if (self.supportModel.rbValue === 'rbNdg') {
              self.labelPlaceholderChangeOption(property, 'LBL_NDG', 'PF_INSERT_NDG');
            } else if (self.supportModel.rbValue === 'rbCF') {
              self.labelPlaceholderChangeOption(property, 'LBL_SOCIETY_CF', 'PLACEHOLDER_FISCAL_CODE_CORPORATE');
            } else if (self.supportModel.rbValue === 'rbPiva') {
              self.labelPlaceholderChangeOption(property, 'LBL_PF_PIVA', 'LBL_PIVA_PLACEHOLDER');
            }
            self.defaultMode = property;
            break;
          case "PERSONA":
            self.type = "F";
            if (self.supportModel.rbValue === 'rbNdg') {
              self.labelPlaceholderChangeOption(property, 'LBL_NDG', 'PF_INSERT_NDG');
            } else if (self.supportModel.rbValue === 'rbCF') {
              self.labelPlaceholderChangeOption(property, 'LBL_PERSONAL_FISCAL_CODE', 'PLACEHOLDER_FISCAL_CODE_PERSONAL');
            } else if (self.supportModel.rbValue === 'rbPiva') {
              self.labelPlaceholderChangeOption(property, 'LBL_PF_PIVA', 'LBL_PIVA_PLACEHOLDER');
            }
            self.defaultMode = property;
            break;
          default:
            console.log("error option", property);
        }
        self.supportModel.subjectResponse = {
          metadata: {
            riUserG: RiUserG.build(),
            riUserF: Pf.build()
          }
        }
        self.validityCustomerDigital(false);
        //se cambio opzione sbianco il modello
        self.exportModel({
          model: null
        });
        self.supportModel.cf = "";
        if (self.id === 'RICHPREVE') {
          self.supportModel.endSearchRest = false;
        }
      }

      self.searchCfResponse = function (subjectResponse, modelValue, sedeType) {

        if (!subjectResponse.metadata[modelValue][sedeType]) {
          self.supportModel.validityCf = false;
          if (sedeType === "residenza") {
            var residenza = Residenza.build();
            subjectResponse.metadata[modelValue][sedeType] = residenza;
          } else {
            var sedeLegale = Sede.build();
            subjectResponse.metadata[modelValue][sedeType] = sedeLegale;
          }
        } else {
          self.supportModel.validityCf = subjectResponse.metadata[modelValue][sedeType].indirizzo ? true : false;

        }

        if (!subjectResponse.metadata[modelValue][sedeType].luogoEsteso) {
          subjectResponse.metadata[modelValue][sedeType].luogoEsteso = {};
          subjectResponse.metadata[modelValue][sedeType].luogoEsteso.nome = subjectResponse.metadata[modelValue][sedeType].comune;
          subjectResponse.metadata[modelValue][sedeType].luogoEsteso.sigla = subjectResponse.metadata[modelValue][sedeType].provincia;
          subjectResponse.metadata[modelValue][sedeType].luogoEsteso.codiceCatastale = null;
          subjectResponse.metadata[modelValue][sedeType].luogoEsteso.cap = [];
          subjectResponse.metadata[modelValue][sedeType].luogoEsteso.cap[0] = subjectResponse.metadata[modelValue][sedeType].cap;
        }

        if (!subjectResponse.metadata[modelValue][sedeType].stato) {
          subjectResponse.metadata[modelValue][sedeType].stato = Stato.build();
        }

        if (!subjectResponse.metadata[modelValue][sedeType].statoEsteso) {
          subjectResponse.metadata[modelValue][sedeType].statoEsteso = Stato.build();
        }
      }

      self.searchCf = function () {
        if (self.loaderLente) {
          return;
        }
        self.pivaIncorrect = false;
        self.ricercaEffettuata = false;
        self.notFound = false;
        self.loaderLente = true;
        self.showSearchFallbackF = false;
        Object.keys(self.supportModel).forEach(function (x) {
          if (
            x == "cf" ||
            x == "valueModel" ||
            x == "labelProductType" ||
            x == "rbValue"
          ) {
            return;
          } else if (x == "indirizzoCliente" || x == "sedeLegale") {
            Object.keys(self.supportModel[x]).forEach(function (el) {
              if (el != "stato") {
                self.supportModel[x][el] = null;
              }
            });
          } else {
            self.supportModel[x] = null;
          }
        });
        self.supportModel.endSearchRest = false;

        // switch (self.defaultMode) {
        //   case "AZIENDA":
        //     self.type = "G";
        //     break;
        //   case "PERSONA":
        //     self.type = "F";
        //     break;
        //   default:
        //     self.type = undefined;
        // }

        if (!self.supportModel.rbValue && self.id !== "RICHPREVE") {
          self.type = null;
        }
        var isRichiestaPreventivo = false;
        if (self.id == "RICHPREVE") {
          isRichiestaPreventivo = true;
        }
        self.supportModel.anagCancelled = false;
        $financialApiService
          .searchSubject(self.supportModel.cf, self.type, self.supportModel.rbValue, isRichiestaPreventivo)
          .then(function (subjectResponse) {
            self.supportModel.endSearchRest = !self.supportModel.endSearchRest;

            if (subjectResponse.success == false) {
              self.pivaIncorrect = subjectResponse.keyMessage == 'ERROR_PIVA_INCORRECT' ? true : false;
              self.loaderLente = false;
              self.ricercaEffettuata = false;
              if (self.id === "RICHPREVE") {
                self.notFound = true;
                self.supportModel.notFound = 1;
                if (self.supportModel.rbValue) {
                  self.financialCustomer.metadata.riUserG = RiUserG.build({
                    cf: self.supportModel.cf
                  })
                } else {
                  self.financialCustomer.metadata.riUserG = RiUserG.build({
                    ndg: self.supportModel.cf
                  })
                }
              } else if (self.id === "vendorPaymentDetail" || self.id == "additionalGoodInfo" || self.id == "POSTVENDITA") {
                var comuni = self.mapComuni.concat(self.mapComuniNsilSoppressi);
                if (isNaN(self.supportModel.cf)) {
                  if (self.supportModel.rbValue == "rbPiva") {
                    subjectResponse = {
                      metadata: {
                        riUserG: RiUserG.build({
                          piva: self.supportModel.cf
                        }),
                        riUserF: Pf.build({ cf: self.supportModel.cf }).setDefaultPfValues(self.nazioniEstere, comuni)
                      }
                    }

                  } else if (self.supportModel.rbValue == "rbCF") {
                    subjectResponse = {
                      metadata: {
                        riUserG: RiUserG.build({
                          cf: self.supportModel.cf
                        }),
                        riUserF: Pf.build({ cf: self.supportModel.cf }).setDefaultPfValues(self.nazioniEstere, comuni)
                      }
                    }
                  } else {
                    subjectResponse = {
                      metadata: {
                        riUserG: RiUserG.build(),
                        riUserF: Pf.build({ cf: self.supportModel.cf }).setDefaultPfValues(self.nazioniEstere, comuni)
                      }
                    }
                  }
                } else {
                  if (self.supportModel.rbValue == "rbPiva") {
                    subjectResponse = {
                      metadata: {
                        riUserG: RiUserG.build({
                          piva: self.supportModel.cf
                        }),
                        riUserF: Pf.build()
                      }
                    }

                  } else if (self.supportModel.rbValue == "rbCF") {
                    subjectResponse = {
                      metadata: {
                        riUserG: RiUserG.build({
                          cf: self.supportModel.cf
                        }),
                        riUserF: Pf.build()
                      }
                    }

                  } else {
                    subjectResponse = {
                      metadata: {
                        riUserG: RiUserG.build(),
                        riUserF: Pf.build()
                      }
                    }

                  }

                }
                if (subjectResponse.metadata.riUserG.cciaaPvInvalid) {
                  self.invalidProv = subjectResponse.metadata.riUserG.cciaaPv;
                  subjectResponse.metadata.riUserG.cciaaPv = '';
                }
                self.supportModel.subjectResponse = subjectResponse;
                self.currentCustomer = subjectResponse.metadata.riUserG;
                if (self.invalidProv) {
                  Object.assign(self.currentCustomer, {
                    invalidProv: self.invalidProv
                  })
                }
                self.supportModel.datiIncompleti = (!RiUserG.build(subjectResponse.metadata.riUserG).isOk(false, false, false, true) || subjectResponse.metadata.riUserG.cciaaPvInvalid || (!subjectResponse.metadata.riUserG.dataAvvioAttivita && checkIfMandatoryDataAvvioAttivita(subjectResponse.metadata.riUserG.formaGiuridica))) && !!!subjectResponse.metadata.riUserG.ndg
              }
              self.validityCustomerDigital(false);
            } else {
              self.loaderLente = false;
              if (subjectResponse && subjectResponse.metadata && subjectResponse.metadata.riUserG && subjectResponse.metadata.riUserG.warningAnagrafica &&
                ((subjectResponse.metadata.riUserG.warningAnagrafica.sofferenza && subjectResponse.metadata.riUserG.warningAnagrafica.blocking) || subjectResponse.metadata.riUserG.inBlacklist) && self.id == 'RICHPREVE') {
                $modalService.openModal("highSufferingRiskModal");
              } else {
                if (subjectResponse.metadata) {
                  if (subjectResponse.type === 'G' &&
                    (self.id === 'insuredSubject' || self.impostaRegistro)) {
                    $rootScope.$broadcast('addAlert', {
                      text: 'NOTIFICA_SUBJECT_NOT_PHYSICAL'
                    });
                    self.validityCustomerDigital(false);
                    self.invalidField = true;
                  }
                  if (self.id == 'RICHPREVE') {
                    self.financialCustomer.metadata.riUserF.listaPf = [];
                  }
                  self.ricercaEffettuata = true;
                  self.supportModel.subjectResponse = subjectResponse;

                  if (subjectResponse.metadata.riUserG) {
                    self.supportModel.anagCancelled = subjectResponse.metadata.riUserG.deleted;
                    self.supportModel.valueModel = 'riUserG';
                    self.searchCfResponse(subjectResponse, 'riUserG', 'sedeLegale')
                    self.supportModel.indirizzoCliente = subjectResponse.metadata.riUserG.sedeLegale;

                    if (subjectResponse.metadata.riUserG.sedeConsegna) {
                      self.searchCfResponse(subjectResponse, 'riUserG', 'sedeConsegna');
                    }

                    if (subjectResponse.metadata.riUserG.sedeFatturazione) {
                      self.searchCfResponse(subjectResponse, 'riUserG', 'sedeFatturazione');
                    }

                    self.supportModel.ragioneSociale = subjectResponse.metadata.riUserG.ragioneSociale;
                    self.supportModel.sedeLegale = subjectResponse.metadata.riUserG.sedeLegale;
                    self.supportModel.formaGiuridica = subjectResponse.metadata.riUserG.formaGiuridica;

                    self.supportModel.nominativo = null;

                    if (!subjectResponse.metadata.riUserG.sedeLegale.stato) {
                      subjectResponse.metadata.riUserG.sedeLegale.stato = {};
                    }

                    if (self.id == 'POSTVENDITA') {
                      if (self.financialCustomer) {
                        self.financialCustomer.riUserG = subjectResponse.metadata.riUserG;
                      }
                    } else {
                      if (self.financialCustomer) {
                        self.financialCustomer.metadata.riUserG = subjectResponse.metadata.riUserG;
                      }
                    }



                    if (subjectResponse.metadata.riUserG.cciaaPvInvalid) {
                      self.invalidProv = subjectResponse.metadata.riUserG.cciaaPv;
                      subjectResponse.metadata.riUserG.cciaaPv = '';
                    }

                    self.inBlacklist = subjectResponse.metadata.riUserG.inBlacklist;
                    self.currentCustomer = subjectResponse.metadata.riUserG;
                    if (self.invalidProv) {
                      Object.assign(self.currentCustomer, {
                        invalidProv: self.invalidProv
                      })
                    }
                    if (self.id != "RICHPREVE") {
                      self.supportModel.datiIncompleti = ((!RiUserG.build(subjectResponse.metadata.riUserG).isOk(false, false, false, true) || subjectResponse.metadata.riUserG.cciaaPvInvalid || (!subjectResponse.metadata.riUserG.dataAvvioAttivita && checkIfMandatoryDataAvvioAttivita(subjectResponse.metadata.riUserG.formaGiuridica))) && !!!subjectResponse.metadata.riUserG.ndg)
                    }

                    self.validityModel(subjectResponse);

                  } else {
                    self.supportModel.valueModel = 'riUserF';
                    if (subjectResponse.metadata.riUserF) {
                      self.supportModel.anagCancelled = subjectResponse.metadata.riUserF.deleted;
                      self.searchCfResponse(subjectResponse, 'riUserF', 'residenza')
                      self.supportModel.indirizzoCliente = subjectResponse.metadata.riUserF.residenza;
                      self.supportModel.datiNascita = subjectResponse.metadata.riUserF.datiNascita

                      var nominavoCompleto =
                        subjectResponse.metadata.riUserF.nome + " " + subjectResponse.metadata.riUserF.cognome;
                      if (subjectResponse.metadata.riUserF.nome && subjectResponse.metadata.riUserF.cognome) {
                        self.supportModel.nominativo = nominavoCompleto;
                      }
                      self.supportModel.ragioneSociale = subjectResponse.metadata.riUserF.ragSoc;
                    } else {
                      // PERSONA FISICA NON CENSITA
                      subjectResponse.metadata.riUserF = Pf.build(subjectResponse);
                      subjectResponse.metadata.riUserF.cf = self.supportModel.cf;
                      self.supportModel.indirizzoCliente = Residenza.build();
                    }

                    self.validityModel(subjectResponse);
                  }
                }

                self.showSearchFallbackF = subjectResponse.showSearchFallbackF;

                if (self.ricercaEffettuata) {
                  if (self.showSearchFallbackF) {
                    self.validityCustomerDigital(false);
                    self.exportValiditySede(true);
                  } else {
                    if (self.supportModel.datiIncompleti && self.id != "RICHPREVE") {
                      self.validityCustomerDigital(false);
                    } else {
                      self.validityCustomerDigital(true);
                    }
                  }
                } else {
                  self.validityCustomerDigital(false);
                }

                if (self.inBlacklist) {
                  self.validityCustomerDigital(false);
                }
                self.ricercaEffettuata = true;
              }
              checkAndEnableTooltip();
            }
          })
          .catch(function (err) {
            console.log(err)
          })
          .finally(function () {
            self.loaderLente = false;
          })
      }

      self.toggleAlertMsg = function () {
        self.errorMsgShown = !self.errorMsgShown;
      };

      self.validityCustomerDigital = function (validity) {
        self.exportValidityCustomerDigital({
          validity
        })
      }

      self.validityModel = function (subjectResponse) {
        $timeout(function () {
          self.exportModel({
            model: subjectResponse.metadata
          });
        }, 500)
      }

      self.validateCf = function (validity) {
        self.exportValidateCf({
          validity
        })
      }

      self.exportValiditySede = function (validity) {
        self.validitySede = validity;
        self.handleChange('sedeLegale', self.supportModel.indirizzoCliente);
      }

      self.validityCf = function (cf, cognome, nome) {
        self.supportModel.validityCf = validationService.checkCfWithName(cf, cognome, nome)
      }

      self.checkProductType = function () {
        if (self.id == 'POSTVENDITA') {
          self.supportModel.labelProductType = 'LBL_RESIDENZA';
        } else {
          switch (self.productType) {
            // F = FORNITORE 
            case 'F':
              self.supportModel.labelProductType = 'LBL_INDIRIZZO_FORNITORE';
              break;
            // A = SOGGETTO ASSICURATO
            case 'A':
              self.supportModel.labelProductType = 'LBL_INDIRIZZO_SOGGETTO_ASSICURATO';
              break;
            case 'MOB':
            case 'MOZ':
            case 'FVM':
            case 'GOM':
            case 'OPS':
            case 'IMM':
              self.supportModel.labelProductType = 'LBL_PROPERTY_ADDRESS';
              break;
            case 'FER':
              self.supportModel.labelProductType = 'LBL_PROPERTY_ADDRESS_FER';
              break;
            case 'FLY':
              self.supportModel.labelProductType = 'LBL_PROPERTY_OWNER_ADDRESS_FLY';
              break;
            case 'NAV':
              self.supportModel.labelProductType = 'LBL_PROPERTY_OWNER_ADDRESS_NAV';
              break;
            case 'ADV':
              self.supportModel.labelProductType = 'LBL_PROPERTY_SUBJECT_ADV';
              break;
            case 'CESS':
              self.supportModel.labelProductType = 'LBL_SEDE_LEGALE';
              break;
            case 'VOL':
              self.supportModel.labelProductType = 'LBL_SEDE_LEGALE';
              break;
            default:
              self.supportModel.labelProductType = 'LBL_PROPERTY_ADDRESS';
          }
        }
      }

      var checkAndEnableTooltip = function () {
        self.infoSede = "";
        $timeout(function () {
          if (self.supportModel.valueModel == "riUserG" || self.type === "G") {
            if (self.supportModel.sedeLegale) {
              self.infoSede = self.supportModel.sedeLegale.typeStreet + " " + self.supportModel.sedeLegale.indirizzo + " " + self.supportModel.sedeLegale.numeroCivico + " " + self.supportModel.sedeLegale.cap + " " + self.supportModel.sedeLegale.comune + " " + self.supportModel.sedeLegale.provincia;
              if (self.infoSede.length > self.numberOfCharMax) {
                self.enableTooltipSede = true;
              } else {
                self.enableTooltipSede = false;
              }
            }
          }
          if (self.supportModel.valueModel == "riUserF" || self.type === "F") {
            if (self.supportModel.indirizzoCliente) {
              self.infoSede = self.supportModel.indirizzoCliente.typeStreet + " " +
                self.supportModel.indirizzoCliente.indirizzo + ' ' +
                self.supportModel.indirizzoCliente.numeroCivico + ' ' +
                self.supportModel.indirizzoCliente.cap + ' ' +
                self.supportModel.indirizzoCliente.comune + ' ' +
                self.supportModel.indirizzoCliente.provincia;
              if (self.infoSede.length > self.numberOfCharMax) {
                self.enableTooltipIndirizzo = true;
              } else {
                self.enableTooltipIndirizzo = false;
              }
            }
          }
          if (self.supportModel && self.supportModel.ragioneSociale && self.supportModel.ragioneSociale.length > self.numberOfCharMaxRagSoc) {
            self.enableTooltipRagioneSociale = true;
          } else {
            self.enableTooltipRagioneSociale = false;
          }
        }, 1000);
      }

      self.closeModal = function (modalId) {

        $modalService.closeModal(modalId);
        self.supportModel.cf = '';

      }

      self.updateCustomer = function () {
        self.enableModal = true;
        $timeout(function () {
          jQuery("#footerInstant").css("z-index", "-1");
          jQuery('.financial-leasing__footer').css("z-index", "-1");
          $modalService.openModal("updateCustomerData");
        }, 500)
      }

      self.undoModal = function (value) {
        $modalService.closeModal("updateCustomerData");
        self.enableModal = false;

      }

      self.saveUpdatedData = function (value) {

        if (value && $giuridicVersion.checkIfInd(value.formaGiuridica)) {
          self.showSearchFallbackF = true;
        }
        self.supportModel.formaGiuridica = value.formaGiuridica;
        $modalService.closeModal("updateCustomerData");
        self.enableModal = false;
        self.supportModel.sedeLegale = value.sedeLegale;
        self.supportModel.ragioneSociale = value.ragioneSociale
        self.ricercaEffettuata = true;
        checkAndEnableTooltip();
        self.supportModel.datiIncompleti = ((!RiUserG.build(value).isOk(false, false, false, true) || value.cciaaPvInvalid || (!value.dataAvvioAttivita && checkIfMandatoryDataAvvioAttivita(value.formaGiuridica))) && !!!value.ndg);

        if (self.supportModel.datiIncompleti) {
          self.validityCustomerDigital(false);
        } else {
          if (
            value && $giuridicVersion.checkIfInd(value.formaGiuridica) ||
            value && value.formaGiuridica ==
            "PEF"
          ) {
            self.supportModel.subjectResponse.metadata.riUserF.cf = self.supportModel.subjectResponse.metadata.riUserG.cf
            var sendSubject = {
              metadata: {
                riUserG: value,
                riUserF:
                  self.supportModel.subjectResponse &&
                  self.supportModel.subjectResponse.metadata &&
                  self.supportModel.subjectResponse.metadata.riUserF,
              },
            };
          } else {
            var sendSubject = {
              metadata: {
                riUserG: value,
                riUserF: Pf.build()
              },
            };
          }
          self.validityCustomerDigital(true);
          self.validityModel(sendSubject);
        }

      }

      var listOfLegalStatusNotDataAvvioAttivita = function () {
        $typeDomainService.getDomainSet('FORMA_GIURIDICA', 'NO_DATA_AVVIO_ATTIVITA')
          .then(function (response) {
            self.listOfFreeLegalStatus = response.domainList;
          })
      }

      var checkIfMandatoryDataAvvioAttivita = function (legalStatus) {

        return legalStatus && self.listOfFreeLegalStatus &&
          self.listOfFreeLegalStatus.every(
            function (element) {
              return element.value != legalStatus
            })
      }

      self.isNanFunction = function (value) {
        return isNaN(value)
      }

      self.deleteInsSubject = function () {
        if (!self.supportModel.subjectResponse) {
          self.searchCf();
      
          const searchCfCompleting = function () {
            if (self.supportModel.endSearchRest) {
              self.supportModel.subjectResponse.metadata.riUserF = Pf.build();
              removeSubject()
              self.validityModel(self.supportModel.subjectResponse);
              self.validityCustomerDigital(true)
            } else {
              setTimeout(searchCfCompleting, 200);
            }
          };
          searchCfCompleting();
        } else {
          self.supportModel.subjectResponse.metadata.riUserF = Pf.build();
          removeSubject()
          self.validityModel(self.supportModel.subjectResponse);
          self.validityCustomerDigital(true)
        }
      };

      var removeSubject = function() {
        Object.keys(self.supportModel).forEach(function (x) {
          if (
            x == "valueModel" ||
            x == "labelProductType" ||
            x == "rbValue" ||
            x == "subjectResponse"
          ) {
            return;
          } else if (x == "indirizzoCliente" || x == "sedeLegale") {
            Object.keys(self.supportModel[x]).forEach(function (el) {
              if (el != "stato") {
                self.supportModel[x][el] = null;
              }
            });
          } else {
            self.supportModel[x] = null;
          }
        });
      }

    }
  })